import {createReducer} from '@reduxjs/toolkit';

import setActiveQuad from '../actions/set-active-quad';
import {modes, setMode} from '../actions/ui';
import {
  set as setGeometry,
  setByCoordinate as setGeometryByCoordinate,
  setByExtent as setGeometryByExtent,
} from '../actions/geometry';

export const initialState = null;

export default createReducer(initialState, {
  [setActiveQuad]: (state, {payload: quad}) => quad && quad.id,
  [setGeometry]: () => initialState,
  [setGeometryByCoordinate]: () => initialState,
  [setGeometryByExtent]: () => initialState,
  [setMode]: (state, {payload: mode}) => {
    if (mode === modes.NONE || mode === modes.COMPARE) {
      return initialState;
    }
    return state;
  },
});
